/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetLoanBalanceWithParamsParams,
  LoanBalanceDto,
  LoanBalanceRequestDto
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Retrieves loan balance details including unpaid principal and accrued interest
 * @summary Get loan balance information
 */
export const getLoanBalance = (
    loanBalanceRequestDto: LoanBalanceRequestDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanBalanceDto>(
      {url: `/api/v1/loans/balance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanBalanceRequestDto, signal
    },
      options);
    }
  


export const getGetLoanBalanceMutationOptions = <TError = LoanBalanceDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLoanBalance>>, TError,{data: LoanBalanceRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getLoanBalance>>, TError,{data: LoanBalanceRequestDto}, TContext> => {

const mutationKey = ['getLoanBalance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getLoanBalance>>, {data: LoanBalanceRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  getLoanBalance(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetLoanBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof getLoanBalance>>>
    export type GetLoanBalanceMutationBody = LoanBalanceRequestDto
    export type GetLoanBalanceMutationError = LoanBalanceDto

    /**
 * @summary Get loan balance information
 */
export const useGetLoanBalance = <TError = LoanBalanceDto,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLoanBalance>>, TError,{data: LoanBalanceRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getLoanBalance>>,
        TError,
        {data: LoanBalanceRequestDto},
        TContext
      > => {

      const mutationOptions = getGetLoanBalanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Retrieves loan balance details including unpaid principal and accrued interest
 * @summary Get loan balance information using query parameters
 */
export const getLoanBalanceWithParams = (
    params: GetLoanBalanceWithParamsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LoanBalanceDto>(
      {url: `/api/v1/loans/balance/details`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetLoanBalanceWithParamsInfiniteQueryKey = (params?: GetLoanBalanceWithParamsParams,) => {
    return [
    'infinite', `/api/v1/loans/balance/details`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetLoanBalanceWithParamsQueryKey = (params?: GetLoanBalanceWithParamsParams,) => {
    return [
    `/api/v1/loans/balance/details`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetLoanBalanceWithParamsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoanBalanceWithParams>>>, TError = unknown>(params: GetLoanBalanceWithParamsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanBalanceWithParamsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanBalanceWithParams>>> = ({ signal }) => getLoanBalanceWithParams(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanBalanceWithParamsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanBalanceWithParams>>>
export type GetLoanBalanceWithParamsInfiniteQueryError = unknown


export function useGetLoanBalanceWithParamsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanBalanceWithParams>>>, TError = unknown>(
 params: GetLoanBalanceWithParamsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanBalanceWithParams>>,
          TError,
          Awaited<ReturnType<typeof getLoanBalanceWithParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanBalanceWithParamsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanBalanceWithParams>>>, TError = unknown>(
 params: GetLoanBalanceWithParamsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanBalanceWithParams>>,
          TError,
          Awaited<ReturnType<typeof getLoanBalanceWithParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanBalanceWithParamsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanBalanceWithParams>>>, TError = unknown>(
 params: GetLoanBalanceWithParamsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan balance information using query parameters
 */

export function useGetLoanBalanceWithParamsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoanBalanceWithParams>>>, TError = unknown>(
 params: GetLoanBalanceWithParamsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanBalanceWithParamsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoanBalanceWithParamsQueryOptions = <TData = Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError = unknown>(params: GetLoanBalanceWithParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanBalanceWithParamsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanBalanceWithParams>>> = ({ signal }) => getLoanBalanceWithParams(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoanBalanceWithParamsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanBalanceWithParams>>>
export type GetLoanBalanceWithParamsQueryError = unknown


export function useGetLoanBalanceWithParams<TData = Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError = unknown>(
 params: GetLoanBalanceWithParamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanBalanceWithParams>>,
          TError,
          Awaited<ReturnType<typeof getLoanBalanceWithParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanBalanceWithParams<TData = Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError = unknown>(
 params: GetLoanBalanceWithParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanBalanceWithParams>>,
          TError,
          Awaited<ReturnType<typeof getLoanBalanceWithParams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoanBalanceWithParams<TData = Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError = unknown>(
 params: GetLoanBalanceWithParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan balance information using query parameters
 */

export function useGetLoanBalanceWithParams<TData = Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError = unknown>(
 params: GetLoanBalanceWithParamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanBalanceWithParams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoanBalanceWithParamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




